import { render, staticRenderFns } from "./SelectRecordCase.vue?vue&type=template&id=1e06eb00&"
import script from "./SelectRecordCase.vue?vue&type=script&lang=js&"
export * from "./SelectRecordCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports